module.exports = __webpack_public_path__ + "img/zeda_logo_bottom.d6ee94fa.svg";